import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-magic-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50 whitespace-nowrap">
                非麻瓜漫画
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              非麻瓜漫画，汇聚最全魔法漫画、奇幻漫画与异能漫画。免费下拉式阅读，畅享魔法世界漫画大全。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-50 font-heading font-semibold mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={`/category/${cat.slug}`}
                    onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-heading font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="/"
                  onClick={(e) => { e.preventDefault(); navigate('/'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  首页
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  onClick={(e) => { e.preventDefault(); navigate('/about'); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  读者公约
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  版权声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-heading font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line mt-0.5"></i>
                <span>contact@feimanggua.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-customer-service-2-line mt-0.5"></i>
                <span>合作&投稿</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>中国 · 北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 非麻瓜漫画. 保留所有权利. | 本站所有漫画内容均来自网络，版权归原作者所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">DMCA</a>
          </div>
        </div>
      </div>
    </footer>
  );
}